import { type SVGAttributes } from 'react';
import { cn } from '@/lib/cn';

interface SpinnerProps extends Pick<SVGAttributes<SVGSVGElement>, 'aria-hidden'> {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
} as const;

export function Spinner({ size = 'md', className, 'aria-hidden': ariaHidden }: SpinnerProps) {
  return (
    <svg
      className={cn('animate-spin text-current', sizeClasses[size], className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role={ariaHidden ? undefined : 'status'}
      aria-label={ariaHidden ? undefined : 'Loading'}
      aria-hidden={ariaHidden}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
